import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease, delay }}
    >
      {children}
    </C>
  );
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, animateOnLoad = false }) => {
  const trigger = animateOnLoad
    ? { animate: "show" }
    : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span className={`block ${className}`} initial="hide" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hide: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.05, ease, delay: delay + i * 0.12 }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
